<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书  >  操作指南  >  实名认证  >  证书查询  >  我的证书 </div>
    </div>
    <div class="auto padding250">
       <p class="title">我的证书</p>
      <div class="container ">
      <div class="img">
        <img src="../../assets/zhengshu2.png" alt=""><img src="../../assets/zhuanhuan.png" alt="" class="change">
        <img src="../../assets/zhengshu1.png" alt="">
         <router-link to="/zhengshu" style="display: none;">证书换新</router-link>
         <router-link to="/zhengshu">学分认定</router-link>
      </div>
      <div class="img">
        <img src="../../assets/zhengshu3.png" alt=""><img src="../../assets/zhuanhuan.png" alt="" class="change">
        <img src="../../assets/zhengshu1.png" alt="">
         <router-link to="/zhengshu" style="display: none;">证书换新</router-link>
         <router-link to="/zhengshu">学分认定</router-link>
      </div>

      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
    }
    .container{
      background-color: #fff;
      padding: 40px;
      margin-top: 10px;
      .img{
        background-color: #F5F5F5;
        border:1px solid #dbdbdb;
        padding: 40px;
        margin-bottom: 40px;
      }
      img{
        vertical-align: middle;
      }
      .change{
        margin: 0 60px;
      }
      a{
        color: #fff;
        display: inline-block;
        width: 220px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #073C68;
        float: right;
        margin-top: 50px;

      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'

    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changeScore/myzhengshu.vue